import {
  MIN_NO_OF_USES,
  MAX_TAG_ON_MOBILE,
  MAX_TAG_ON_TABLET
} from './client-constants'
import { OfferDetailType } from '../types/StorePageType'
import { TagType } from '../offer-tags/offerTags'
import { Breakpoint } from './useBreakpoint'
import { FormatMessage } from './useWorldReady'

type GetOfferTags = (
  data: OfferDetailType,
  breakpoints: Breakpoint,
  formatMessage: FormatMessage
) => OffertTags[]
type GetLabelTags = (
  data: OfferDetailType,
  breakpoints: Breakpoint,
  formatMessage: FormatMessage
) => labelTags[]
interface OffertTags {
  type: TagType
  text: string
  className: string
}
interface labelTags {
  text: string
}
export const getOfferTags: GetOfferTags = (
  offerData,
  { isTablet, isMobile },
  formatMessage
) => {
  let offerTags: OffertTags[] = []
  if (offerData.couponCode) {
    offerTags.push({
      type: 'COUPON_CODE',
      text: formatMessage('main.storePage.offerDetails.codeTag'),
      className: 'label-code'
    })
  }

  if (offerData.expiresIn) {
    offerTags.push({
      type: 'EXPIRATION_DATE',
      text: `${offerData.expiresIn}h`,
      className: 'label-expiry'
    })
  }

  if (offerData.uses && offerData.uses > MIN_NO_OF_USES) {
    offerTags.push({
      type: 'NUM_OF_USES',
      text: formatMessage('main.storePage.offerDetails.uses', {
        //regex for splitting number with "," at units places
        number: offerData.uses
          .toString()
          .split(/(?=(?:\d{3})+(?:\.|$))/g)
          .join(',')
      }),
      className: 'label-uses'
    })
  }

  if (offerData.lastUsed) {
    offerTags.push({
      type: 'LAST_USED',
      text: formatMessage('main.storePage.offerDetails.lastUsed', {
        number: offerData.lastUsed
      }),
      className: 'label-last-used'
    })
  }

  if (offerData.lastSaved) {
    offerTags.push({
      type: 'LAST_SAVED',
      text: formatMessage('main.storePage.offerDetails.lastSaved', {
        number: offerData.lastSaved
      }),
      className: 'label-last-saved'
    })
  }

  offerTags =
    offerTags.length > 3 && isTablet
      ? offerTags.slice(0, MAX_TAG_ON_TABLET)
      : offerTags
  offerTags =
    offerTags.length > 1 && isMobile
      ? offerTags.slice(0, MAX_TAG_ON_MOBILE)
      : offerTags
  return offerTags
}

export const getOfferLabels: GetLabelTags = (
  offerData,
  { isMobile },
  formatMessage
) => {
  let labelTags: labelTags[] = []
  if (offerData.exclusive) {
    labelTags.push({
      text: formatMessage('main.storePage.offerDetails.exclusiveText')
    })
  }
  if (
    offerData.meta.couponClass &&
    offerData.meta.couponClass.toLocaleLowerCase() !== 'honey exclusive'
  ) {
    labelTags.push({
      text: offerData.meta.couponClass
    })
  }
  if (offerData.meta.percentOff) {
    labelTags.push({
      text: formatMessage('main.storePage.type.discountTag', {
        percent: offerData.meta.percentOff
      })
    })
  }
  labelTags =
    labelTags.length > 1 && isMobile
      ? labelTags.slice(0, MAX_TAG_ON_MOBILE)
      : labelTags
  return labelTags
}
